<template>
  <path
    d="M19.5 9.50024C18.47 9.50024 17.6 10.1202 17.21 11.0002H14.29C13.9 10.1202 13.03 9.50024 12 9.50024C10.97 9.50024 10.1 10.1202 9.71 11.0002H6.79C6.4 10.1202 5.53 9.50024 4.5 9.50024C3.12 9.50024 2 10.6202 2 12.0002C2 13.3802 3.12 14.5002 4.5 14.5002C5.53 14.5002 6.4 13.8802 6.79 13.0002H9.71C10.1 13.8802 10.97 14.5002 12 14.5002C13.03 14.5002 13.9 13.8802 14.29 13.0002H17.21C17.6 13.8802 18.47 14.5002 19.5 14.5002C20.88 14.5002 22 13.3802 22 12.0002C22 10.6202 20.88 9.50024 19.5 9.50024Z"
  />
</template>
